import { render, staticRenderFns } from "./OperatorHistory.vue?vue&type=template&id=2fae36a2&scoped=true"
import script from "./OperatorHistory.vue?vue&type=script&lang=js"
export * from "./OperatorHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae36a2",
  null
  
)

export default component.exports